<template>
  <div class='start-wrapper'>
    <div class="language-button">
      <a class="el-button el-button--info" href="https://cn.shop.yundaorders.com" style="text-decoration: none; color: #f0f0f0; font-weight: bold;">中文简体</a>
    </div>
    <div class='start-form' v-if="showStart">
      <img src="..\..\public\images\58brother logo.png" alt="yundaLogo" class='yunda-logo'>
      <div class="form-1">
        <!-- <div style="text-align: left">
          <i class="material-icons" style="font-size: 48px; cursor: pointer" @click="showStart = false">arrow_back</i>
        </div> -->
        <h2>Enter your Email Address to start</h2>
        <input type="email" class="email-input" v-model="emailInput" autofocus>
        <div class="help-text">{{ warningTxt }}</div>
        <button class='start-button' @click="toForm">Start Shipping</button>
      </div>
    </div>
    <div class='start-form' v-else>
      <img src="..\..\public\images\58brother logo.png" alt="yundaLogo" class='yunda-logo'>
      <div class="form-2">
        <h2>Enter 4-digit Store Code to continue</h2>
        <div style="font-size: 18px; color: #0000ff; margin-bottom: 12px" @click="showList = true">View store code list</div>
        <input v-model="codeInput" maxlength="4" type="number" class="code-input" autofocus>
        <div>
          <button class="go-button" @click="toStart">GO</button>
        </div>
      </div>
    </div>
    <div class="code-list-wrapper" v-show="showList">
      <div class="code-list">
        <el-button type="primary" style="width: 100%; margin-bottom: 20px;" @click="showList = false">Back to shipping</el-button>
        <div class="code-item" v-for="item in stores" :key="item.mapIndex">
          <div class="store-code">{{ item.shortCode }}</div>
          <div>
            <div class="store-name">{{ item.name }}</div>
            <div class="store-address">{{ item.addressStr }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import MaterialDesignInput from '@/components/MaterialDesignInput'

export default {
  name: 'ShopStart',
  props: ['stores', 'tempEmail'],
  data () {
    return {
      emailInput: this.tempEmail,
      codeInput: '',
      warningTxt: '',
      showStart: false,
      tempStore: null,

      showList: false
    }
  },
  methods: {
    toForm: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.emailInput).toLowerCase())
      if (!result) {
        this.warningTxt = 'Please enter valid email address'
        return
      }
      if (result) {
        this.warningTxt = ''
      }
      this.$emit('open-form', {
        email: this.emailInput,
        store: this.tempStore
      })
    },
    toStart: function () {
      let code = this.codeInput
      for (var i = 0; i < this.stores.length; i++) {
        if (this.stores[i].shortCode === code) {
          this.tempStore = JSON.parse(JSON.stringify(this.stores[i]))
          break
        }
      }
      if (!this.tempStore) {
        this.$message.error('Please input correct 4-digit code of the store.')
        return
      }
      this.showStart = true
    }
  },
  watch: {
    emailInput: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.emailInput).toLowerCase())
      if (!result) {
        this.warningTxt = 'An email with your shipping detail will be sent to you'
      } else {
        this.warningTxt = ''
      }
    }
  },
  components: {
    MaterialDesignInput
  }
}
</script>

<style>
.start-form {
  margin: 60px auto auto auto;
  width: 900px;
}
.form-1 {
  background-color: #f9f9f9;
  box-sizing: border-box;
  padding: 40px 40px;
  border-radius: 60px;
  box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
  animation: slideRight 0.8s ease;
}
.form-2 {
  background-color: #f9f9f9;
  box-sizing: border-box;
  padding: 40px 40px;
  border-radius: 60px;
  box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.8s ease;
}
h2 {
  font-size: 42px;
  color: #333;
  margin-bottom: 30px;
}
.code-input {
  height: 200px;
  width: 380px;
  font-size: 160px;
  text-align: center;
}
.email-input {
  height: 100px;
  width: 100%;
  font-size: 40px;
  text-align: center;
}
.go-button {
  margin-top: 40px;
  width: 200px;
  height: 60px;
  background-color: #fbc02d;
  color: #ffffff;
  border-radius: 40px;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.4s ease
}
.go-button:hover {
  box-shadow: 0 28px 50px -25px #F9A825;
}
.start-wrapper {
  background-color: #494949;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}
/* .start-form {
  margin: 10vh auto auto auto;
  width: 50%;
} */
.yunda-logo {
  width: 300px;
  margin: auto;
  padding-bottom: 0;
}
.start-button {
  color: #494949;
  margin-top: 64px;
  width: 200px;
  font-size: 24px;
  padding: 12px;
  background-color: #fbc02d;
  border-radius: 45px;
  border: none;
  cursor: pointer;
  transition: ease 0.4s all;
}
.start-button:hover {
  box-shadow: 0 4px 12px 0 #c49000;
}
.help-text {
  margin-top: 20px;
  font-size: 20px;
  color: #E53935;
}
.code-list-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5);
}
.code-list {
  background-color: #ffffff;
  width: 300px;
  height: 80vh;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -40vh 0 0 -150px;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
  overflow: auto;
  animation: slideUp 0.5s ease;
}
.code-item {
  text-align: left;
  margin-bottom: 16px;
}
.store-name {
  font-size: 14px;
}
.store-address {
  font-size: 12px;
}
.store-code {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 4px;
}
@media (max-width: 768px) {
  .start-form {
    width: 80%;
    margin: auto;
  }
  .start-button {
    color: #494949;
    margin-top: 32px;
    width: 160px;
    font-size: 16px;
    padding: 8px;
    background-color: #fbc02d;
    border-radius: 45px;
    border: 2px solid transparent;
    cursor: pointer;
    transition: ease 0.4s all;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }
  .yunda-logo {
    width: 150px;
    margin: auto;
    padding-bottom: 0;
  }
}
@media (max-width: 600px) {
  h2 {
    font-size: 24px;
    padding: 0 20px;
  }
  .form-1 {
    background-color: #f9f9f9;
    box-sizing: border-box;
    padding: 30px 20px;
    border-radius: 60px;
    box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
  }
  .form-2 {
    background-color: #f9f9f9;
    box-sizing: border-box;
    padding: 30px 20px;
    border-radius: 60px;
    box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
  }
  .code-input {
    height: 100px;
    width: 200px;
    font-size: 60px;
    text-align: center;
  }
  .email-input {
    height: 60px;
    width: 100%;
    font-size: 20px;
    text-align: center;
  }
  .help-text {
    margin-top: 20px;
    font-size: 16px;
    color: #E53935;
  }
}
@keyframes slideRight {
  from { transform: translateY(100px); opacity: 0.5; }
  to { transform: translateY(0); opacity: 1; }
}
@keyframes slideUp {
  from { transform: translateY(100px); opacity: 0.5; }
  to { transform: translateY(0); opacity: 1; }
}
</style>
